<template>
  <Echart :id="post.id" :chartData="chartData" />
</template>

<script setup>
import { computed, defineAsyncComponent, onMounted } from "vue";

const props = defineProps({
  template: {
    type: String,
    default: "Bar",
  },
  post: {
    type: Object,
    required: true,
  },
});

// Extract data handling to a separate computed property for clarity
const chartData = computed(() => {
  if (!props.post) {
    console.warn("Echart: post prop is undefined or null.");
    return {
      category: { data: [] },
      series1: { name: "", data: [], unit: "" },
      series2: { name: "", data: [], unit: "" },
    };
  }

  const { category, series1, series2 } = props.post;

  return {
    category: { data: category?.data || [] },
    series1: {
      name: series1?.name || "",
      data: series1?.data || [],
      unit: series1?.unit || "",
    },
    series2: {
      name: series2?.name || "",
      data: series2?.data || [],
      unit: series2?.unit || "",
    },
  };
});

// Load chart component dynamically
const Echart = defineAsyncComponent(() =>
  import(`@/components/apps/chart/${props.template}.vue`)
);

// Log when the component is mounted (optional, for debugging)
onMounted(() => {
  // console.log(`Echart component (${props.template}) mounted.`);
});
</script>
